module.exports = __webpack_public_path__ + "static/apigif-cc2012c9a473ec8cd41a7932e88100b5.gif";